import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHandleNotifications from "../../Hooks/useHandleData/useHandleNotifications";
import PropTypes from "prop-types";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import ActionSheet from "devextreme-react/action-sheet";
import { useScreenSize } from "../../Utils/media-query";
import "./styles.css";
import Alert from "@mui/material/Alert";
import SideNav from "./SideNavBar";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import { getUsersEmail, getUsersName } from "../../Utils/helper";
import useAuth from "../../Hooks/useAuth";
import { useLocation } from "react-router-dom";
import useGetEmployeesOfTheMonth from "../../Hooks/useGET/useGetAllEmployeesOfTheMonth";
import santaHat from "../../Assets/images/santa.png";
import Snowfall from "react-snowfall";

const today = new Date();
const month = today.getMonth(); // 11 = December
const day = today.getDate();
const titleText = "ATLAS Board";

const isHolidayMode = month === 11 && day >= 16 && day <= 31;

const menuStyle = { padding: "0 0 0 20px" },
  notificationStyle = {
    display: "flex",
    justifyContent: "center",
  },
  curserStyle = { cursor: "pointer" };

const NavBar = ({ pageTitle }) => {
  const [isVisible, setVisibility] = useState(false),
    { notificationData } = useHandleNotifications(),
    [notifications, setNotifications] = useState([]),
    [btnToggle, setBtnToggle] = useState(false),
    //[menuToggleEnabled, setMenuToggleEnabled] = useState(false),
    [isActionSheetVisible, setIsActionSheetVisible] = useState(false),
    [isPinned, setIsPinned] = useState(false),
    navigate = useNavigate(),
    wrapperRef = useRef(null),
    auth = useAuth(),
    { isXSmall, isLarge } = useScreenSize();
  const location = useLocation();
  const { current, isLoading, error } = useGetEmployeesOfTheMonth();
  const eomName = current?.user?.name ?? (isLoading ? "Loading…" : "—");
  const eomLab = current?.user?.assignedLocation ?? "";
  const userEmail = getUsersEmail();

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setBtnToggle(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (notificationData) {
      setNotifications(notificationData);
    }
  }, [notificationData]);

  const toggleMenu = () => {
    setVisibility(!isVisible);
  };

  const renderIcon = () => {
    let name = getUsersName() || "";
    let rgx = /(\p{L}{1})\p{L}+/gu;

    // FIX: Only call matchAll on a valid string
    let matches = name ? Array.from(name.matchAll(rgx)) : [];

    let initials = (
      (matches.shift()?.[1] || "") + (matches.pop()?.[1] || "")
    ).toUpperCase();

    return (
      <div className="circle" style={curserStyle}>
        <div className="initials">{initials}</div>
      </div>
    );
  };

  let pathName = window.location.pathname;
  pathName = pathName.replace(/\/[^\/]*$/, "");

  const Logout = () => {
    auth.logout();
  };

  const actionSheetItems = [
    // { text: "Profile", onClick: () => console.log("profile") },

    {
      text: "My Profile",
      icon: "user",

      stylingMode: "outlined",
      onClick: () => navigate("/my-profile"),
    },
    {
      text: "Logout",
      icon: "runner",

      stylingMode: "outlined",
      onClick: () => Logout(),
    },
  ];

  const handleMouseEnter = () => setIsActionSheetVisible(true);

  const handleMouseLeave = () => {
    if (!isPinned) setIsActionSheetVisible(false);
  };

  const handleButtonClick = () => {
    setIsPinned(!isPinned);
    setIsActionSheetVisible(!isPinned); // Toggle visibility based on new pin state
  };

  const onProfileClick = (e) => {
    setIsActionSheetVisible(!isActionSheetVisible);
  };

  return (
    <div className="header-container">
      {isHolidayMode && (
        <>
          <Snowfall
            color="white"
            snowflakeCount={150}
            style={{
              position: "fixed",
              width: "100vw",
              height: "100vh",
              top: 0,
              left: 0,
              pointerEvents: "none",
              zIndex: 5, // above background but under modals
            }}
          />
        </>
      )}
      <header>
        {/*menu button*/}
        <Toolbar className="header-toolbar">
          {/*ATLAS logo*/}
          <Item
            location="before"
            cssClass="logo-button"
            onClick={() => {
              navigate("/");
            }} /*visible={isXSmall}*/
          >
            <button>
              <img
                src={atlasLogo}
                alt="Atlas Logo"
                width="75"
                height="60"
                style={{
                  position: "fixed",
                  top: "18px", // adjust distance from top
                  left: "36px",
                  cursor: "default",
                  margin: "0px",
                }}
              />
            </button>
          </Item>
          {/*ATLAS Board title*/}
          <Item
            location="before"
            cssClass="header-title"
            render={() => (
              <div
                className={`atlas-title ${
                  isHolidayMode ? "atlas-title--holiday" : ""
                }`}
                onClick={() => navigate("/")}
              >
                {titleText.split("").map((ch, i) => (
                  <span
                    key={i}
                    className={`atlas-letter ${
                      ch === " " ? "atlas-letter-space" : ""
                    }`}
                    style={{ animationDelay: `${i * 0.15}s` }} // stagger each letter
                  >
                    {ch === " " ? "\u00A0" : ch}
                  </span>
                ))}
              </div>
            )}
          />

          <Item location="center" cssClass="header-notice-item">
            <div
              className="header-notice__container"
              title={notificationData}
              aria-label="WSU purchasing notice"
            >
              {notificationData?.length > 0 && (
                <Alert severity="warning" className="header-notice__content">
                  {" "}
                  {notificationData}{" "}
                </Alert>
              )}
            </div>
          </Item>

          {/*profile button*/}
          <Item location="after">
            {/* employee of the month */}
            <div
              className={`employee-pill ${
                location.pathname === "/" ? "employee-pill--portal" : ""
              }`}
              onClick={() => navigate("/employees-of-the-month")}
              style={{ cursor: "pointer" }}
              title="See all Employees of the Month"
              aria-label="Employees of the Month"
            >
              <ion-icon name="trophy-outline"></ion-icon>
              <div className="employee-text">
                <span className="employee-name">{eomName}</span>
                <span className="employee-lab">{eomLab}</span>
              </div>
            </div>

            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button onClick={handleButtonClick}>{renderIcon()}</button>
            </div>
          </Item>
        </Toolbar>

        <ActionSheet
          title={userEmail}
          target=".dx-toolbar-after"
          usePopover={true}
          width="250px"
          items={actionSheetItems}
          visible={isActionSheetVisible}
          elementAttr={{ class: "modern-actionsheet" }} // Add custom class
          onHiding={() => setIsPinned(false)} // Reset pin state if closed externally
        />
      </header>
      {/* hide the side navbar from the portal page */}
      {location.pathname !== "/" && (
        <SideNav isVisible={isVisible} setVisibility={setVisibility} />
      )}
    </div>
  );
};

NavBar.propTypes = {
  pageTitle: PropTypes.string,
};

NavBar.defaultProps = {
  pageTitle: "",
};

export default NavBar;
